import { ElementDefinition } from '@amzn/exs-elements/web-component';
import { ExsElementsHydrationPlugin } from '@amzn/exs-gem-react/plugins';
import { SettingsSchema } from '@amzn/exs-elements-interface';
import schema from './config/settings-schema.json';
import { getClientSideMetricsPlugin } from '../../common/client-side-metrics-plugin';

const accountLinkingCardTagName = 'amazon-account-linking-card';

const accountLinkingCardVersion = 'v1.0';

export const accountLinkingCard: ElementDefinition = {
    tagName: accountLinkingCardTagName,
    schema: schema as SettingsSchema,
    shadowMode: 'closed',
    version: accountLinkingCardVersion,
    plugins: [
        ExsElementsHydrationPlugin({
            clientEntryPath: `/elements/${accountLinkingCardTagName}/${accountLinkingCardVersion}/entry-client.js`,
        }),
        getClientSideMetricsPlugin(accountLinkingCardTagName),
    ],
};
